import { API } from 'constant/constants';
import axiosClient from '../axiosClient';

const uploadApi = {
  uploadToS3(data: FormData) {
    const url = API.UPLOAD.S3
    return axiosClient.post(url, data)
  },
}

export default uploadApi
